import React from "react";
import {
  HiOutlineLocationMarker,
  HiOutlineMail,
  HiOutlineAcademicCap,
} from "react-icons/hi";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { personalInfo, education } from "../../data";

function About() {
  const leftRef  = useScrollReveal();
  const rightRef = useScrollReveal();

  return (
    <section id="about" className="section about-section">
      <div className="section-inner">
        <div className="about-grid">
          <div ref={leftRef} className="reveal-left">
            <p className="section-label">About</p>
            <h2 className="section-title">
              Who I <span>Am</span>
            </h2>
            <p className="about-bio">{personalInfo.bio}</p>

            <div className="about-info-list">
              <div className="about-info-row">
                <HiOutlineLocationMarker className="about-info-icon" />
                <span>{personalInfo.location}</span>
              </div>
              <div className="about-info-row">
                <HiOutlineMail className="about-info-icon" />
                <a href={`mailto:${personalInfo.email}`}>{personalInfo.email}</a>
              </div>
              <div className="about-info-row">
                <AiFillGithub className="about-info-icon" />
                <a href={personalInfo.github} target="_blank" rel="noreferrer">
                  github.com/AhmadRAbuhussein
                </a>
              </div>
              <div className="about-info-row">
                <FaLinkedinIn className="about-info-icon" />
                <a href={personalInfo.linkedin} target="_blank" rel="noreferrer">
                  linkedin.com/in/ahmad-abu-hussein
                </a>
              </div>
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              <a href={`mailto:${personalInfo.email}`} className="btn-primary">
                Say Hello
              </a>
              <a href={personalInfo.github} target="_blank" rel="noreferrer" className="btn-secondary">
                GitHub
              </a>
            </div>
          </div>

          <div ref={rightRef} className="reveal about-col-right">
            <h3>Education</h3>

            {education.map((edu, i) => (
              <div key={i} className="about-edu-card">
                <div className="about-edu-degree">
                  <HiOutlineAcademicCap style={{ marginRight: "6px", verticalAlign: "middle", color: "var(--accent-light)" }} />
                  {edu.degree}
                </div>
                <div className="about-edu-institution">{edu.institution}</div>
                <div className="about-edu-period">
                  {edu.location} &nbsp;·&nbsp; {edu.period}
                </div>
              </div>
            ))}

            <div style={{ marginTop: "32px" }}>
              <h3 style={{ marginBottom: "16px" }}>Quick Facts</h3>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {[
                  "5+ years building production systems",
                  "Experienced in logistics, fintech, food-tech, HR & IoT",
                  "Led teams of 3-4 engineers",
                  "Expert in .NET & React ecosystems",
                  "Clean Architecture & TDD advocate",
                ].map((fact, i) => (
                  <div key={i} style={{ display: "flex", gap: "10px", alignItems: "flex-start", fontSize: "0.875rem", color: "var(--text-secondary)" }}>
                    <span style={{ color: "var(--accent-light)", flexShrink: 0, marginTop: "2px" }}>▸</span>
                    <span>{fact}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
